module.exports = __webpack_public_path__ + "assets/img/tsgn5.98e60d10.png";